module.exports = __webpack_public_path__ + "img/article-lock.4c982a19.png";